import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const inventoriesService = new Service('/storage/movements/inventory', HALApiService, createItemsData)
